export default __webpack_public_path__ + "static/media/bg-image.12ae290b.png";